class VgMap {
	constructor(options = {}) {
		this.lang = options.lang || "es";

		this.options = options;

		this.woosmapKey = vgMapData.woosmap_key;
		this.searchDistance = options.searchDistance || 7000;
		this.searchOptions = this.initSearchOptions();
		this.map;
		this.mapStyle = this.initMapStyle();
		this.markerIcon = this.initMarkerIcon();
		this.markerIconSelected = this.initMarkerIconSelected();
		this.closeIcon = this.initCloseIcon();
		this.isJoining = options.isJoining || false;
		this.userPosition;
		this.positionAccuracy = 100;
		this.fixedPositions = {
			"es": { latitude: 40.45557016703023, longitude: -3.7689266740482807 },
			"pt": { latitude: 39.7263707848344, longitude: -8.676799479950342 },
		};
		this.marker;
		this.markersArray = [];
		this.centerMarker;
		this.gyms;
		this.filteredGyms;
		this.selectedGym;

		this.multiSearch = null;
		this.inputElement = null;
		this.suggestionsList = null;
		this.clearSearchBtn = null;

		this.mapPanel = null;
		this.resultsPanel;

		this.itemsPerPage = 6;
		this.initialPage = 1;
		this.currentPage = 1;
		this.currentData;

		this.country = VgHelpers.getCountry();
		this.locale  = VgHelpers.getLanguage();
		this.gymList = this.setGymList();

		this.loadScripts();
	}

	loadScripts() {
		const woosmapScript = document.createElement("script");
		const multiSearchScript = document.createElement("script");

		woosmapScript.src = `https://sdk.woosmap.com/map/map.js?key=${this.woosmapKey}&callback=initMap`;
		woosmapScript.defer = true;

		multiSearchScript.src = `https://sdk.woosmap.com/multisearch/multisearch.js`;
		multiSearchScript.defer = true;

		document.head.appendChild(multiSearchScript);
		document.head.appendChild(woosmapScript);

		window.initMap = this.initMap.bind(this);
	}

	async initMap() {
		this.mapPanel = document.getElementsByClassName("vg-map__map-panel")[0];
		this.resultsPanel = document.getElementsByClassName(
			"vg-map__search-results-panel-list"
		)[0];

		if (this.isJoining) {
			this.initMapSwitchButtons();
			this.initPagination();
		}

		let includeAllGyms = false;

		try {
			this.userPosition = await this.getUserLocation();
			console.log('User position Accuracy', this.userPosition.accuracy);
			if (parseInt(this.userPosition.accuracy) > this.positionAccuracy) {
				console.log("User position accuracy is too low, centering on " + this.lang.toUpperCase() + " fixed position");
				this.userPosition = this.fixedPositions[this.lang];
				includeAllGyms = true;
			}
		} catch (error) {
			console.error("Failed to get user position:", error);
		}

		try {
			this.gyms = await this.getAllGyms();
		} catch (error) {
			console.error("Failed to get all gyms", error);
		}

		this.map = new window.woosmap.map.Map(
			document.getElementById(this.options.mapSelectorId),
			{
				center: {
					lat: this.userPosition.latitude,
					lng: this.userPosition.longitude,
				},
				zoom: 10,
				styles: this.mapStyle,
			}
		);

		this.showAllGyms();

		if (this.options.centerOnUser && !this.options.center) {
			this.addCenterMarker({
				lat: this.userPosition.latitude,
				lng: this.userPosition.longitude,
			});
			// TODO: We already have zoomToAllGyms, we should use it here instead boolean
			this.zoomToNearestGyms(
				{
					lat: this.userPosition.latitude,
					lng: this.userPosition.longitude,
				},
				false,
				false,
				includeAllGyms,
			);
		} else if (this.options.center) {
			this.addCenterMarker({
				lat: this.options.center.lat,
				lng: this.options.center.lng,
			});
			this.zoomToNearestGyms(
				{ lat: this.options.center.lat, lng: this.options.center.lng },
				false,
				false,
				false
			);
		} else {
			this.zoomAllGyms();
		}

		if (this.options.selectedGymId && this.options.selectedGymId !== null) {
			let selectedId = this.options.selectedGymId.toString();
			let selectedGym = this.getGymById(selectedId);
			if (!selectedGym) {
				console.error("Selected gym not found");
				return;
			}
			this.selectedGym = selectedGym;
			this.activeMarker(selectedId);
			this.zoomToSelectedGym(selectedGym);
		}




		this.initSearch();

		document.dispatchEvent(
			new CustomEvent("vgMapReady", { detail: this.map })
		);

		// TODO: Remove this after testing
		//this.showListPanel(this.gyms.features, this.initialPage);
	}

	async setGymList(){
        const vgApiClient = new VgApiClient(this.country, this.locale);
		this.gymList = await vgApiClient.getGymsByRegionFromDatabase(this.country);
		console.log('GymList', this.gymList);
	}

	centerMapTo(latitude, longitude) {
		this.map.setCenter({ lat: latitude, lng: longitude });
	}

	async updateLanguage(lang) {
		this.filteredGyms = this.gyms.features.filter(
			(gym) =>
				gym.properties.user_properties.VisibleInNewJP === "true" &&
				gym.properties.address.country_code.toLowerCase() === lang
		);

		// TODO: Remove this after testing
		//this.showAllGyms();
		//this.zoomAllGyms();
		this.showListPanel(this.filteredGyms, this.initialPage);
	}

	async getWoosmapGeolocation() {
		try {
			const result = await fetch(
				`https://api.woosmap.com/geolocation/position/?key=${this.woosmapKey}`
			);
			const position = await result.json();
			return position;
		} catch (error) {
			console.error("Failed to get user position");
			throw error;
		}
	}

	async getUserLocation() {
		return new Promise((resolve, reject) => {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						resolve({
							latitude: position.coords.latitude,
							longitude: position.coords.longitude,
							accuracy: position.coords.accuracy,
						});
						console.log(position);
					},
					async (error) => {
						console.log("Browser geolocation failed, falling back to Woosmap", error);
						try {
							const woosmapPosition = await this.getWoosmapGeolocation();
							resolve(woosmapPosition);
						} catch (woosmapError) {
							reject(woosmapError);
						}
					},
					{
						enableHighAccuracy: true,
						maximumAge: 0,
						forceAndroidLocationManager: true,
					}
				);
			} else {
				console.log("Browser geolocation is not supported, falling back to Woosmap");
				this.getWoosmapGeolocation()
					.then((position) => resolve(position))
					.catch((woosmapError) => reject(woosmapError));
			}
		});
	}

	async getAllGyms() {
		try {
			const result = await fetch(
				`https://api.woosmap.com/stores/?key=${this.woosmapKey}&stores_by_page=300`
			);
			const gyms = await result.json();
			const pageCount = parseInt(gyms.pagination.pageCount);
			if (pageCount > 1) {
				console.log("More than one page of gyms, fetching all pages");
				let page = 2;
				while (page <= pageCount) {
					const pageResult = await fetch(
						`https://api.woosmap.com/stores/?key=${this.woosmapKey}&page=${page}`
					);
					const gymsPage = await pageResult.json();
					gyms.features = gyms.features.concat(gymsPage.features);
					page++;
				}
			}
			console.log("All gyms fetched", gyms);

			gyms.features = gyms.features.filter(
				(gym) =>
					gym.properties.user_properties.VisibleInNewJP === "true"
			);
			return gyms;
		} catch (error) {
			console.error("Failed to get all gyms");
			throw error;
		}
	}

	getGymById(id) {
		return this.gyms.features.find((gym) => gym.properties.store_id === id);
	}

	getMarkerByGymById(id) {
		return this.markersArray.find((marker) => marker.store_id === id);
	}

	activeMarker(id) {
		let selectedMarker = this.getMarkerByGymById(id);
		this.selectedMarker = selectedMarker;
		selectedMarker.setIcon(
			`data:image/svg+xml;base64,${this.markerIconSelected}`
		);
		if (this.selectedMarker && this.selectedMarker !== selectedMarker) {
			this.selectedMarker.setIcon(
				`data:image/svg+xml;base64,${this.markerIcon}`
			);
		}
		// clear all previous markers
		this.markersArray.forEach((marker) => {
			if (marker.store_id !== id) {
				marker.setIcon(`data:image/svg+xml;base64,${this.markerIcon}`);
			}
		});
	}

	removeMarkers() {
		this.markersArray.forEach((marker) => {
			marker.setMap(null);
		});
	}

	showAllGyms() {
		let bounds = new woosmap.map.LatLngBounds();
		this.removeMarkers(); // revisar
		this.gyms.features.forEach((gym) => {
			let gymMarker = new woosmap.map.Marker({
				map: this.map,
				position: new woosmap.map.LatLng(
					gym.geometry.coordinates[1],
					gym.geometry.coordinates[0]
				),
				icon: `data:image/svg+xml;base64,${this.markerIcon}`,
				store_id: gym.properties.store_id,
			});

			this.markersArray.push(gymMarker);

			gymMarker.addListener("click", () => {
				if (this.selectedMarker) {
					this.selectedMarker.setIcon(
						`data:image/svg+xml;base64,${this.markerIcon}`
					);
				}
				this.showMapPanel(gym);
				this.nearestGyms = this.filterNearestGyms(
					{
						lat: gym.geometry.coordinates[1],
						lng: gym.geometry.coordinates[0],
					},
					this.searchDistance,
					this.gyms
				);
				this.showListPanel(this.nearestGyms, this.initialPage);

				let marginLeft = window.innerWidth > 500 ? 500 : 100;
				this.map.flyTo({
					animate: true,
					center: gymMarker.getPosition(),
					padding: {
						top: 100,
						bottom: 100,
						left: marginLeft,
						right: 100,
					},
					essential: false,
				});

				gymMarker.setIcon(
					`data:image/svg+xml;base64,${this.markerIconSelected}`
				);

				if (this.selectedMarker && this.selectedMarker !== gymMarker) {
					this.selectedMarker.setIcon(
						`data:image/svg+xml;base64,${this.markerIcon}`
					);
				}

				this.selectedMarker = gymMarker;
			});
		});

		this.map.addListener("click", () => {
			this.hideMapPanel();
			if (this.selectedMarker) {
				this.selectedMarker.setIcon(
					`data:image/svg+xml;base64,${this.markerIcon}`
				);
				this.selectedMarker = null;
			}
		});

		this.map.fitBounds(
			bounds,
			{ top: 100, bottom: 100, left: 100, right: 100 },
			true
		);
	}

	zoomAllGyms() {
		let bounds = new woosmap.map.LatLngBounds();
		this.gyms.features.forEach((gym) => {
			bounds.extend(
				new woosmap.map.LatLng(
					gym.geometry.coordinates[1],
					gym.geometry.coordinates[0]
				)
			);
		});

		this.map.fitBounds(
			bounds,
			{ top: 100, bottom: 100, left: 100, right: 100 },
			true
		);
	}

	zoomToNearestGyms(originPosition, showPanel = true, animate = true, includeAllGyms = false) {

		if (!includeAllGyms) {
			this.nearestGyms = this.filterNearestGyms(originPosition);
		} else {
			this.nearestGyms = this.gyms.features;
		}

		let bounds = new woosmap.map.LatLngBounds();

		this.nearestGyms.forEach((gym) => {
			bounds.extend(
				new woosmap.map.LatLng(
					gym.geometry.coordinates[1],
					gym.geometry.coordinates[0]
				)
			);
		});

		if (originPosition) {
			bounds.extend(originPosition);
		}

		if (this.nearestGyms.length === 1) {
			let nearestGym = this.nearestGyms[0];
			let gymCoords = new woosmap.map.LatLng(
				nearestGym.geometry.coordinates[1],
				nearestGym.geometry.coordinates[0]
			);
			if (nearestGym.properties.distance < this.searchDistance) {
				this.zoomToSelectedGym(nearestGym);
				if (showPanel) {
					this.showMapPanel(nearestGym);
				}
				this.showListPanel([nearestGym], this.initialPage);
			} else {
				bounds = new woosmap.map.LatLngBounds();
				bounds.extend(originPosition);
				bounds.extend(gymCoords);
				this.map.fitBounds(
					bounds,
					{ top: 100, bottom: 100, left: 100, right: 100 },
					false
				);
			}
		} else {
			this.showListPanel(this.nearestGyms, this.initialPage);

			if (showPanel) {
				this.showListOnMapPanel(this.nearestGyms);
			}

			this.map.flyTo({
				animate: animate,
				center: originPosition,
				zoom: 14,
				essential: false,
			});
			this.map.fitBounds(
				bounds,
				{ top: 100, bottom: 100, left: 100, right: 100 },
				animate
			);
		}
	}

	zoomToSelectedGym(selectedGym) {
		let gymLatLng = {
			lat: selectedGym.geometry.coordinates[1],
			lng: selectedGym.geometry.coordinates[0],
		};
		this.nearestGyms = this.filterNearestGyms(gymLatLng);

		this.showMapPanel(selectedGym);
		this.showListPanel([selectedGym], this.initialPage);
		this.activeMarker(selectedGym.properties.store_id);

		this.map.flyTo({
			animate: true,
			center: gymLatLng,
			zoom: 14,
			padding: { top: 100, bottom: 100, left: 100, right: 100 },
			essential: false,
		});
	}

	showMapPanel(gym) {
		this.mapPanel.classList.remove("list-mode");
		this.mapPanel.style.opacity = 1;
		this.mapPanel.innerHTML = this.createElementHTML(gym.properties);
		this.mapPanel
			.querySelector(".vg-map__info-window-close")
			.addEventListener("click", () => {
				this.hideMapPanel();
			});
		this.addListenerToSubscribeButton(this.mapPanel);
	}

	hideMapPanel() {
		this.mapPanel.style.opacity = 0;
		this.emptyMapPanel();
	}

	emptyMapPanel() {
		this.mapPanel.innerHTML = "";
	}

	showListOnMapPanel(gyms) {
		if (!this.isJoining) {
			return;
		}
		this.mapPanel.classList.add("list-mode");
		this.mapPanel.style.opacity = 1;
		this.mapPanel.innerHTML = "<ul>";
		gyms.forEach((item) => {
			this.mapPanel.innerHTML += this.createListElementHTML(
				item.properties
			);
		});
		this.mapPanel.innerHTML += "</ul>";
		this.addListenerToSubscribeButton(this.mapPanel);
	}

	showListPanel(selectedGyms, page) {
		if (!this.isJoining) {
			return;
		}

		const startIndex = (page - 1) * this.itemsPerPage;
		const endIndex = startIndex + this.itemsPerPage;
		let pageItems = selectedGyms.slice(startIndex, endIndex);
		this.currentData = selectedGyms;
		const pageFrom = document.getElementById("current-page");
		const pageTo = document.getElementById("page-number");

		// If select gym and is on nearestGyms group, move to first position. If not, show only selected gym
		if (selectedGyms.length === 1) {
			let isOnNearestGyms = this.gymOnArray(
				this.nearestGyms,
				selectedGyms[0]
			);

			if (isOnNearestGyms) {
				this.nearestGyms = this.nearestGyms.filter(
					(gym) =>
						gym.properties.store_id !==
						selectedGyms[0].properties.store_id
				);
				this.nearestGyms.sort(
					(a, b) => a.properties.distance - b.properties.distance
				);
				this.nearestGyms.unshift(selectedGyms[0]);

				pageItems = this.nearestGyms.slice(startIndex, endIndex);
				this.currentData = this.nearestGyms;
				selectedGyms = this.nearestGyms;

				this.resultsPanel = document.getElementsByClassName(
					"vg-map__search-results-panel-list"
				)[0];
				this.resultsPanel.innerHTML = "";
				pageItems.forEach((item) => {
					this.resultsPanel.innerHTML += this.createListElementHTML(
						item.properties
					);
				});
				this.addListenerToSubscribeButton(this.resultsPanel);
			} else {
				this.resultsPanel = document.getElementsByClassName(
					"vg-map__search-results-panel-list"
				)[0];
				this.resultsPanel.innerHTML = this.createListElementHTML(
					selectedGyms[0].properties
				);
				this.addListenerToSubscribeButton(this.resultsPanel);
			}
		} else {
			this.resultsPanel = document.getElementsByClassName(
				"vg-map__search-results-panel-list"
			)[0];
			this.resultsPanel.innerHTML = "";
			pageItems.forEach((item) => {
				this.resultsPanel.innerHTML += this.createListElementHTML(
					item.properties
				);
			});
			this.addListenerToSubscribeButton(this.resultsPanel);
		}

		pageFrom.value = page;
		pageTo.textContent = Math.ceil(selectedGyms.length / this.itemsPerPage);
	}

	goToPreviousPage() {
		if (this.currentPage > 1) {
			this.currentPage--;
			this.showListPanel(this.currentData, this.currentPage);
		}
	}

	goToNextPage() {
		if (
			this.currentPage <
			Math.ceil(this.currentData.length / this.itemsPerPage)
		) {
			this.currentPage++;
			this.showListPanel(this.currentData, this.currentPage);
		}
	}

	goToPage(page) {
		if (
			page >= 1 &&
			page <= Math.ceil(this.currentData.length / this.itemsPerPage)
		) {
			this.currentPage = page;
			this.showListPanel(this.currentData, this.currentPage);
		}
	}

	initPagination() {
		document
			.getElementById("previous-button")
			.addEventListener("click", () => this.goToPreviousPage());
		document
			.getElementById("next-button")
			.addEventListener("click", () => this.goToNextPage());
		document
			.getElementById("current-page")
			.addEventListener("keypress", function (event) {
				const input = document.getElementById("current-page");
				if (event.key === "Enter") {
					const pageNumber = parseInt(input.value);
					this.goToPage(pageNumber);
				}
			});
	}

	gymOnArray(gyms, gym) {
		return gyms.some(function (feature) {
			return feature.properties.store_id === gym.properties.store_id;
		});
	}

	addListenerToSubscribeButton(containerElement) {
		containerElement
			.querySelectorAll(".info-window__cta-subscribe")
			.forEach((btn) => {
				btn.addEventListener("click", () => {
					btn.disabled = true;
					let selectedGym = this.getGymById(btn.dataset.id);
					let gymData = {
						id: selectedGym.properties.store_id,
						name: selectedGym.properties.name,
						country: selectedGym.properties.address.country_code,
						city: selectedGym.properties.address.city,
						openingDate: selectedGym.properties.user_properties.openingDate,
					};
					document.dispatchEvent(
						new CustomEvent("selectedGym", { detail: gymData })
					);
				});
			});
	}

	filterNearestGyms(fromPosition) {
		let nearestGyms = this.gyms.features.filter((gym) => {
			let gymPosition = {
				lat: gym.geometry.coordinates[1],
				lng: gym.geometry.coordinates[0],
			};
			let distance = this.getDistance(fromPosition, gymPosition);
			gym.properties.distance = Math.round(distance);
			return distance < this.searchDistance;
		});

		if (nearestGyms.length > 0) {
			nearestGyms.sort(
				(a, b) => a.properties.distance - b.properties.distance
			);
		} else {
			this.gyms.features.sort(
				(a, b) => a.properties.distance - b.properties.distance
			);
			nearestGyms = [this.gyms.features[0]];
		}

		return nearestGyms;
	}

	addCenterMarker(position) {
		if (this.centerMarker) this.centerMarker.setMap(null);
		this.centerMarker = new woosmap.map.Marker({
			map: this.map,
			position,
			icon: {
				url: this.initCenterIcon(),
			},
		});
	}

	initSearch() {
		this.inputElement = document.getElementsByClassName(
			"vg-map__search-input"
		)[0];
		this.suggestionsList = document.getElementsByClassName(
			"vg-map__search-results"
		)[0];
		this.clearSearchBtn = document.getElementsByClassName(
			"vg-map__search-clear-btn"
		)[0];
		this.resultsPanel = document.getElementsByClassName(
			"vg-map__results-panel"
		)[0];

		if (this.inputElement && this.suggestionsList) {
			this.inputElement.addEventListener(
				"input",
				this.handleAutocomplete.bind(this)
			);
			this.inputElement.addEventListener("keydown", (event) => {
				if (event.key === "Enter") {
					event.preventDefault();
					const firstLi = this.suggestionsList.querySelector("li");
					if (firstLi) firstLi.click();
				}
			});
		}

		this.clearSearchBtn.addEventListener("click", () => {
			this.inputElement.value = "";
			this.suggestionsList.style.display = "none";
			this.clearSearchBtn.style.display = "none";
			this.hideMapPanel();
			this.inputElement.focus();
		});

		this.multiSearch = window.woosmap.multisearch(this.searchOptions);
	}

	initMapSwitchButtons() {
		let vgMapViewControl =
			document.getElementsByClassName("vg-map__woosmap")[0];
		let vgMapSearchContainer =
			document.getElementsByClassName("vg-map__search")[0];
		let switchBtnsForm = document.querySelector(".vg-map__switch-btns");
		let switchBtns = switchBtnsForm.querySelectorAll(
			'input[name="vg-map__switch-btns"]'
		);
		let panelSwitchCountry = document.querySelector(".vg-map__country-selector");

		switchBtns.forEach(function (btn) {
			btn.addEventListener("change", function () {
				vgMapViewControl.classList.remove("map-view", "list-view");
				vgMapSearchContainer.classList.remove("map-view", "list-view");
				panelSwitchCountry.classList.remove("map-view", "list-view");
				vgMapViewControl.classList.add(this.value);
				vgMapSearchContainer.classList.add(this.value);
				panelSwitchCountry.classList.add(this.value);
			});
		});
	}

	handleAutocomplete() {
		if (this.inputElement && this.suggestionsList) {
			const input = this.inputElement.value;

			input.replace('"', '\\"').replace(/^\s+|\s+$/g, "");
			if (input !== "") {
				this.multiSearch.autocompleteMulti(input).then(
					(results) => this.displaySuggestions(results),
					(error) => console.error(`Error autocomplete: ${error}`)
				);
			} else {
				this.suggestionsList.style.display = "none";
				this.clearSearchBtn.style.display = "none";
			}
		}
	}

	handleNoResults() {
		const li = document.createElement("li");

		li.innerHTML = `<div data-testid="search-no-result" class="prediction no-result">${vgMapData.maps_strings.str_no_results}</div>`;
		this.suggestionsList.appendChild(li);
		this.suggestionsList.className = "vg-map__search-results";
		this.suggestionsList.style.display = "block";
	}

	displaySuggestions(results) {
		if (this.inputElement && this.suggestionsList) {
			this.suggestionsList.innerHTML = "";
			if (results.length > 0) {
				results.forEach((result) => {
					let _a;
					const li = document.createElement("li");

					li.className = `${result.api}-api`;
					li.innerHTML =
						(_a = this.formatPredictionList(result)) !== null &&
						_a !== void 0
							? _a
							: "";
					li.addEventListener("click", () => {
						let _a;

						this.inputElement.value =
							(_a = result.description) !== null && _a !== void 0
								? _a
								: "";
						this.suggestionsList.style.display = "none";
						this.multiSearch
							.detailsMulti({ id: result.id, api: result.api })
							.then((details) => {
								if (
									result.api === "localities" ||
									result.api === "address"
								) {
									this.addCenterMarker(
										details.geometry.location
									);
									this.hideMapPanel();
									this.nearestGyms = this.filterNearestGyms(
										details.geometry.location
									);
									this.showListPanel(
										this.nearestGyms,
										this.initialPage
									);
									this.zoomToNearestGyms(
										details.geometry.location
									);
								}
								if (result.api === "store") {
									let selectedGym = this.getGymById(
										result.id
									);
									this.hideMapPanel();
									this.zoomToSelectedGym(selectedGym);
								}
							});
					});
					this.suggestionsList.appendChild(li);
				});
				this.suggestionsList.classList.add(results[0].api);
				this.suggestionsList.style.display = "block";
				this.clearSearchBtn.style.display = "block";
			} else {
				this.handleNoResults();
			}
		}
	}

	formatPredictionList(result) {
		const predictionClass = "no-viewpoint";
		const formatted_name = result.highlight;
		let html = "";

		html += `<div class="icon api-icon"></div><div class="prediction ${predictionClass}">${formatted_name}</div>`;
		return html;
	}

	getDistance(from, to) {
		const R = 6371000; // Radius of the earth in meters
		const toRadians = (degrees) => degrees * (Math.PI / 180);

		const lat1 = toRadians(from.lat);
		const lon1 = toRadians(from.lng);
		const lat2 = toRadians(to.lat);
		const lon2 = toRadians(to.lng);

		const deltaLat = lat2 - lat1;
		const deltaLon = lon2 - lon1;

		const a =
			Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
			Math.cos(lat1) *
				Math.cos(lat2) *
				Math.sin(deltaLon / 2) *
				Math.sin(deltaLon / 2);

		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

		const distance = R * c;
		return Math.round(distance);
	}
	
	flattenGymList(data) {
		let flatGyms = [];
	
		if (Array.isArray(data)) {
			flatGyms = flatGyms.concat(data);
		} else if (typeof data === 'object' && data !== null) {
			for (const key in data) {
				if (data.hasOwnProperty(key)) {
					flatGyms = flatGyms.concat(this.flattenGymList(data[key]));
				}
			}
		}
	
		return flatGyms;
	}

	createElementHTML(gym) {
		let selectedOnJoining =
			this.selectedGym &&
			this.selectedGym.properties.store_id === gym.store_id
				? true
				: false;
		let subscribeBtnText = selectedOnJoining
			? vgMapData.maps_strings.str_selected
			: vgMapData.maps_strings.str_select;
		let servicesList = "";

		if (!this.isJoining) {
			let slug_select_quote = acfSettings.wizard_slug_joining_select_quote;

			var urlJoining = '/' + this.country + '-' + this.locale + '/' + slug_select_quote + '/?gym=' + gym.store_id;
			const flatGyms = this.flattenGymList(this.gymList);
			const searchedStoreId = Number(gym.store_id);
			const gymData = flatGyms.find(gym => gym.store_id === searchedStoreId && gym.permalink);
			var urlGym = '';
			if (gymData) {
				urlGym = gymData.permalink;
			}
		}
		gym.tags.forEach((tag) => {
			servicesList += `
            <li class='service'>
                <span class='icon icon--size-l icon--${tag}'></span>
                <span class='icon__text'>${vgMapData.maps_services[tag]}</span>
            </li>`;
		});

		let element = `
		<li class="vg-map__info-window ${selectedOnJoining ? "selected" : ""}">
			<button class="vg-map__info-window-close" area-label="Close">${
				this.closeIcon
			}</button>
			<div class="vg-map__info-window-header">
				<span class="info-window__title has-h-3-font-size">${gym.name}</span>
				<p class="info-window__location has-subtitle-s-font-size">${
					gym.address.lines
				}</p>
			</div>
			<div class="vg-map__info-window-content">
			<vg-disclosure-group name="details" multiple="false">
				<vg-disclosure media="(max-width: 1280px)" group-name="details" class="info-window__disclosure" heading-selector=".info-window__subtitle">
					<span class="info-window__subtitle has-h-4-font-size">${vgMapData.maps_strings.str_services}</span>
					<ul class="info-window__services">
						${servicesList}
					</ul>
				</vg-disclosure>

				<vg-disclosure media="(max-width: 1280px)" group-name="details" class="info-window__disclosure" heading-selector=".info-window__subtitle">
					<span class="info-window__subtitle has-h-4-font-size">${vgMapData.maps_strings.str_schedule}</span>
					<div class="info-window__schedule">
						${this.getFormattedShedule(gym)}
					</div>
				</vg-disclosure>
			</vg-disclosure-group>
			</div>
			<div class="info-window__cta">
			${!this.isJoining ? `
				<a 
				class="ob-button ob-button--secondary ob-button--outline info-window__cta-read-more" 
				href="${urlGym}" 
				aria-label="${vgMapData.maps_strings.str_see_more}">
					${vgMapData.maps_strings.str_see_more}
				</a>
			` : ""}

			${this.isJoining ? `
				<button 
				class="ob-button info-window__cta-subscribe ${selectedOnJoining ? "ob-button--selected" : ""}" 
				${selectedOnJoining ? "disabled" : ""} 
				data-id="${gym.store_id}">
					${subscribeBtnText}
				</button>
			` : `
				<a 
				href="${urlJoining}" 
				class="ob-button info-window__cta-subscribe ${selectedOnJoining ? "ob-button--selected ob-button--disabled" : ""}" 
				aria-label="${vgMapData.maps_strings.str_subscribe}" 
				${selectedOnJoining ? "aria-disabled='true' tabindex='-1' style='pointer-events: none; opacity: 0.6;'" : ""} 
				data-id="${gym.store_id}">
					${vgMapData.maps_strings.str_subscribe}
				</a>
			`}
			</div>

		</li>`;

		return element;
	}

	createListElementHTML(gym) {
		let selectedOnJoining =
			this.selectedGym &&
			this.selectedGym.properties.store_id === gym.store_id
				? true
				: false;

		let servicesList = "";

		gym.tags.forEach((tag) => {
			servicesList += `
		<li class='service'>
			<span class='icon icon--size-l icon--${tag}'></span>
			<span class='icon__text'>${vgMapData.maps_services[tag]}</span>
		</li>`;
		});

		let element = `
		<li class="vg-map__info-window-item ${selectedOnJoining ? "selected" : ""}">
			<div class="vg-map__info-window-item-header">
				<span class="info-window__title has-h-4-font-size">${gym.name}</span>
				<p class="info-window__location">${gym.address.lines}</p>
			</div>
			<div class="vg-map__info-window-item-content">
				<vg-disclosure-group name="details" multiple="false">
					<vg-disclosure group-name="details" class="info-window__disclosure" heading-selector=".info-window__subtitle">
						<span class="info-window__subtitle">${vgMapData.maps_strings.str_services}</span>
						<ul class="info-window__services">
							${servicesList}
						</ul>
					</vg-disclosure>

					<vg-disclosure group-name="details" class="info-window__disclosure" heading-selector=".info-window__subtitle">
						<span class="info-window__subtitle">${vgMapData.maps_strings.str_schedule}</span>
						<div class="info-window__schedule">
							${this.getFormattedShedule(gym)}
						</div>
					</vg-disclosure>

				</vg-disclosure-group>
			</div>
			<div class="vg-map__info-window-item-cta">
				<button class="ob-button ob-button--compact info-window__cta-subscribe ${
					selectedOnJoining ? "ob-button--disabled" : ""
				}" data-id="${gym.store_id}">${
					selectedOnJoining ? vgMapData.maps_strings.str_selected : vgMapData.maps_strings.str_select
				}</button>
			</div>
		</li>`;

		return element;
	}

	getFormattedShedule(gym) {
		const openingHours = gym.opening_hours.usual;

		const groupTimeTable = [];
		for (const [day, hours] of Object.entries(openingHours)) {
			const timeTable = hours.map(h => `${h.start}-${h.end}`).join(" / ");

			let groupTime = groupTimeTable.find(groupTime => groupTime.hours === timeTable);
			if (!groupTime) {
				groupTime = { hours: timeTable, days: [] };
				groupTimeTable.push(groupTime);
			}
			groupTime.days.push(day);
		}

		const isGroupedDays = this.sameWeekDaysSchedule(groupTimeTable[0].days);

		const groupDaysTimeTable = groupTimeTable.map(groupTime => ({
			days: groupTime.days
				.sort((a, b) => a - b)
				.map(day => vgMapData.maps_strings.str_days[day-1])
				.join(", "),
			hours: groupTime.hours.replace(/-/g, " - "),
		}));

		if (isGroupedDays) {
			groupDaysTimeTable[0].days = vgMapData.maps_strings.str_weekdays;
		}

		const schedule = groupDaysTimeTable.map(groupTime => `
			<p><strong>${groupTime.days}</strong>: ${groupTime.hours}</p>
		`).join("");

		return schedule;
	}

	sameWeekDaysSchedule(days) {
		const weekdays = ['1', '2', '3', '4', '5'];
		return weekdays.every(day => days.includes(day));
	}

	initSearchOptions() {
		return {
			apiOrder: ["store", "localities", "address"],
			debounceTime: 200,
			localities: {
				key: this.woosmapKey,
				fallbackBreakpoint: 0.4,
				minInputLength: 3,
				params: {
					components: {
						country: ['es','pt'],
					},
					language: this.lang,
					types: ["locality", "postal_code", "address"],
					limit: 5,
				},
			},
			store: {
				key: this.woosmapKey,
				fallbackBreakpoint: false,
				minInputLength: 3,
				params: {
					query: "type:vivagym and user.VisibleInNewJP:true",
					limit: 5,
				},
			},
			address: {
				key: this.woosmapKey,
				minInputLength: 3,
				params: {
					components: { country: ['es','pt'] },
					language: this.lang,
				},
			},
		};
	}

	initMarkerIcon() {
		return window.btoa(`
			<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
			<rect width="32" height="32" rx="16" fill="white"/>
			<path d="M16 0C7.16262 0 0 7.16262 0 16C0 24.8374 7.16262 32 16 32C24.8374 32 32 24.8374 32 16C32 7.16262 24.8374 0 16 0ZM24.3821 14.4171L16.7351 23.9436C16.7351 23.9436 16.5722 24.1441 16.4594 24.2109C16.3216 24.2903 16.1712 24.3487 16.0042 24.3487C15.8329 24.3487 15.6826 24.2903 15.5489 24.2109C15.4362 24.1441 15.2733 23.9436 15.2733 23.9436L7.6262 14.4171C6.60715 13.1266 6.8118 11.2221 8.10232 10.1989C9.39285 9.17985 11.2305 9.38449 12.3205 10.6082L15.8121 15.0269C15.9123 15.1522 16.1044 15.1522 16.2005 15.0269L19.692 10.6082C20.782 9.38449 22.6155 9.17985 23.9102 10.1989C25.2007 11.218 25.4054 13.1224 24.3863 14.4171H24.3821Z" fill="#FD5000"/>
			</svg>`);
	}

	initMarkerIconSelected() {
		return window.btoa(`
			<svg xmlns="http://www.w3.org/2000/svg" width="55" height="70" viewBox="0 0 55 70" fill="none">
			<path d="M50 26.5C50 38.9264 39.9264 49 27.5 49C15.0736 49 5 38.9264 5 26.5C5 14.0736 15.0736 4 27.5 4C39.9264 4 50 14.0736 50 26.5Z" fill="white"/>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M27.5 0C42.2143 4.66666e-06 54.2265 11.553 54.9634 26.084L55 27.5C55 27.9347 54.9863 28.3692 54.9658 28.8037C54.9618 28.8893 54.9559 28.9747 54.9512 29.0601C54.9302 29.433 54.9036 29.8057 54.8682 30.1782C54.8624 30.2377 54.8572 30.2971 54.8511 30.3564C52.8008 50.6128 29.8879 70 27.5 70C25.1121 70 2.19661 50.6129 0.146484 30.3564C0.140363 30.2971 0.135138 30.2377 0.129395 30.1782C0.0939635 29.8058 0.067377 29.433 0.0463867 29.0601C0.0416129 28.9747 0.0357317 28.8893 0.0317383 28.8037C0.0112269 28.3692 0 27.9346 0 27.5L0.0366211 26.084C0.773468 11.553 12.7857 0 27.5 0ZM41.0962 17.5293C38.8709 15.7778 35.7188 16.1292 33.8452 18.2324L27.8442 25.8276C27.6792 26.0426 27.35 26.0424 27.1777 25.8276L21.1768 18.2324C19.3032 16.1292 16.1439 15.7778 13.9258 17.5293C11.7077 19.288 11.3564 22.5622 13.1079 24.7803L26.25 41.1523C26.25 41.1523 26.5299 41.4957 26.7236 41.6113C26.9533 41.7477 27.213 41.8506 27.5073 41.8506C27.7943 41.8506 28.0518 41.7476 28.2886 41.6113C28.4803 41.4977 28.7562 41.1597 28.7622 41.1523L41.9067 24.7803H41.9141C43.6655 22.5551 43.314 19.2809 41.0962 17.5293Z" fill="#FD5000"/>
			</svg>`);
	}

	initCloseIcon() {
		return `
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
	        <path d="M1.17652 1.17652L12.8235 12.8235L1.17652 1.17652ZM11.9916 0.344595C12.451 -0.114865 13.1959 -0.114865 13.6554 0.344595C14.1149 0.804055 14.1149 1.54899 13.6554 2.00845L8.66337 6.99951L13.6554 11.9916C14.1149 12.451 14.1149 13.1959 13.6554 13.6554C13.1959 14.1149 12.451 14.1149 11.9916 13.6554L6.99951 8.66337L2.00845 13.6554C1.58181 14.082 0.909017 14.1125 0.447212 13.7468L0.344595 13.6554C-0.114865 13.1959 -0.114865 12.451 0.344595 11.9916L5.33565 6.99951L0.344595 2.00845C-0.114865 1.54899 -0.114865 0.804055 0.344595 0.344595C0.804055 -0.114865 1.54899 -0.114865 2.00845 0.344595L6.99951 5.33565L11.9916 0.344595Z" fill="#FD3183"/>
	        </svg>`;
	}

	initCenterIcon() {
		return "data:image/webp;base64,UklGRioDAABXRUJQVlA4WAoAAAAQAAAAGQAAGQAAQUxQSCABAAABgFxbe9pIXtm7wA6XzPo//Qp2QAW4uIEKqKVAE4Y/YGnGHUQEA7eNFBV2j6m9TyiXYb3R6TTqofIzUKra1by0dsm6W1Uq8DjqMRsQEQHMvUgFjivaEgHmSYDI6ooKioYpPONiOlswA2RQVKQLHo92x/12NCpIR6+VniUYDOPfa5pef+MhDMj2nqgyAdBv4vBNAyCuKtVlAg8/RJJcJE9EPocM4q4KtQGPY5FMCsxE4jHD6LDOAA+/JHFXEvkaMsD1xpKM3p4ld5HLebswtGx0LJnpKRUv09PUkO28MNv/hf3shX+u6NdKmUPKXMj5wp/OF049X7hMKv4kb2l68yX5Z/o7T/qlGlOiZd5mgvzN9La557a5V2izn1HxD4iUQwVWUDgg5AEAABALAJ0BKhoAGgA+kUCbSiWjoiGoCACwEglsAJ0yhHmfs3GpPR1JfUBtgPFJyQD0IP1u6zz9qP2O9lUwF8x3xTZq/VA9C/9cg9FQXEsGuAJVp+vdjOD3kLDhSh9QQwWs4gAA/oV92A+Tn7UEug6h1tE0ghcOP6FWGBcKZmBbwbJlt5Oeyvb61KOOeYKh/sZGd9DIiisMfcyRddJZNbX2Icbsl/yp5JPl//LcDcrHhlsd28BgstihpH90nkQA/qDnGbcsMq6FGpTQJYKG0hu4fw+t8VNZ/+C+eiCS1QzWrqY9WncPVDtI8vsFkl8zLH0Az6NN7ZZ9i/rd32b2LlG1nZtNhWcXNI5hVAPTm3ws0KV7PoQgs/sPJyZ/rHbyvhJgJ/jqqhurAJdBQSYElS3J0wp3qcw7qvP/x5W1bFtZ0ubyK+KWLBtyfFBI/iprO6Kt8fUamPed7I2PSJleUcUvs26PIyBtB2LqNXaLzatXig44sUeKamXhlBnf/7GW+esEMjW/j1p56Uw/e8As8LRzVuTXkQ3AM2pyl45aHDcTSUwsk3oFDS8KHM0deZs6XlGYWH8BsW4lWK9qoSmqRh/+CR4PvxuAcJ7juLXYhqf6C/Rp+0Cy/bVC/idXAiE8ZBJ0Dz7KAAA=";
	}

	initMapStyle() {
		const baseStyle = [
			{
				elementType: "geometry",
				stylers: [{ color: vgMapData.map_colors.geometry }],
			},
			{
				featureType: "landscape.natural",
				stylers: [{ color: vgMapData.map_colors.landscape_natural }],
			},
			{
				featureType: "landscape.man_made",
				stylers: [{ color: vgMapData.map_colors.landscape_man_made }],
			},
			{
				elementType: "labels.text.stroke",
				stylers: [{ visibility: "off" }],
			},
			{
				elementType: "labels.text.fill",
				stylers: [{ color: vgMapData.map_colors.text }],
			},
			{
				featureType: "administrative.locality",
				elementType: "labels.text.fill",
				stylers: [{ color: vgMapData.map_colors.text }],
			},
			{
				featureType: "point_of_interest",
				stylers: [{ visibility: "off" }],
			},
			{
				featureType: "road",
				elementType: "geometry",
				stylers: [{ color: vgMapData.map_colors.road }],
			},
			{
				featureType: "road",
				elementType: "geometry.stroke",
				stylers: [{ color: vgMapData.map_colors.road }],
			},
			{
				featureType: "road",
				elementType: "labels.text.fill",
				stylers: [{ color: vgMapData.map_colors.text }],
			},
			{
				featureType: "road",
				elementType: "labels.text.stroke",
				stylers: [{ visibility: "off" }],
			},
			{
				featureType: "road.local",
				elementType: "geometry",
				stylers: [{ color: vgMapData.map_colors.white }],
			},
			{
				featureType: "transit.line",
				elementType: "geometry",
				stylers: [{ visibility: "off" }],
			},
			{
				featureType: "transit.station",
				elementType: "labels.icon",
				stylers: [{ color: vgMapData.map_colors.text }],
			},
			{
				featureType: "road.highway",
				elementType: "geometry",
				stylers: [{ color: vgMapData.map_colors.road }],
			},
			{
				featureType: "road.highway",
				elementType: "geometry.stroke",
				stylers: [{ color: vgMapData.map_colors.road }],
			},
			{
				featureType: "road.highway",
				elementType: "labels",
				stylers: [{ visibility: "off" }],
			},
			{
				featureType: "road.pedestrian",
				stylers: [{ visibility: "off" }],
			},
			{
				featureType: "transit",
				stylers: [{ visibility: "off" }],
			},
			{
				featureType: "transit.station",
				elementType: "geometry",
				stylers: [{ color: vgMapData.map_colors.station }],
			},
			{
				featureType: "transit.station",
				elementType: "labels.text.fill",
				stylers: [{ color: vgMapData.map_colors.white }],
			},
			{
				featureType: "water",
				elementType: "geometry",
				stylers: [{ color: vgMapData.map_colors.water }],
			},
			{
				featureType: "water",
				elementType: "labels.text.fill",
				stylers: [{ color: vgMapData.map_colors.text }],
			},
			{
				featureType: "water",
				elementType: "labels.text.stroke",
				stylers: [{ visibility: "off" }],
			},
		];

		const colorScheme = (this.options && this.options.colorScheme) || "light";
		if (colorScheme === "dark") {
			baseStyle.push(
				{
					elementType: "geometry",
					stylers: [{ color: "#212121" }],
				},
				{
					elementType: "labels.text.fill",
					stylers: [{ color: "#ffffff" }],
				},
				{
					featureType: "road",
					elementType: "geometry",
					stylers: [{ color: "#2c2c2c" }],
				},
				{
					featureType: "water",
					elementType: "geometry",
					stylers: [{ color: "#0f172a" }],
				}
			);
		}
		
		return baseStyle;
	}
}
